import Label from "components/general/Label";

const { useUrlFriendlyToParameters, useNavigateTo } = require("helpers/urlFriendly");
const { ALL_URL } = require("helpers/utils");
const { useState, useEffect } = require("react");
const { Button } = require("react-bootstrap")


// resetFilterButton: has two behaviours:
// 1- reset with navigation  if filter option is in url
// 2- reset in Parent page if filter is not in url
export const ResetFilterButton = ({
    page = "",
    filterText,
    clearFilterText,
    selectedNoc,
    selectedRecord,
    isBrokenRecordsSelected,
    onClearFilters,
    selectedGender,
    selectedPdfType
}) => {
    // recordPageProps = { selectedNoc: '', selectedRecord: '', isBrokenRecordsSelected: false, onClearFilters: () => { } }
    // medallistsPageProps = { selectedNoc: '', selectedGender: '', onClearFilters: () => { } }
    // multimedallistsPageProps = { selectedNoc: '', selectedGender: '', onClearFilters: () => { } }
    const [paramsUrl, setParamsUrl] = useState({});
    const [shouldNavigate, setShouldNavigate] = useState(false);
    const [isResetFilterButtonDisabled, setIsResetFilterButtonDisabled] = useState(true);

    const params = useUrlFriendlyToParameters();
    useNavigateTo(paramsUrl, shouldNavigate, setShouldNavigate, page);

    useEffect(() => {
        if (page === "multimedallists") {
            if (((params["mirs_discipline"] && params["mirs_discipline"] !== ALL_URL.ALL_DISC)) || (selectedNoc && selectedNoc !== ALL_URL.ALL_NOC) || filterText) {
                setIsResetFilterButtonDisabled(false);
            } else {
                setIsResetFilterButtonDisabled(true);
            }
        } else if (page === "medallists") {
            if ((params["mirs_discipline"] && params["mirs_discipline"] !== ALL_URL.ALL_DISC) || (params["mirs_event"] && params["mirs_event"] !== ALL_URL.ALL_EVENT) || (selectedNoc && selectedNoc !== ALL_URL.ALL_NOC) || (params["mirs_date"] && params["mirs_date"] !== ALL_URL.ALL_DAYS) || filterText || (selectedGender && selectedGender !== "TOT")) {
                setIsResetFilterButtonDisabled(false);
            } else {
                setIsResetFilterButtonDisabled(true);
            }
        } else if (page === "athletes") {
            if (((params["mirs_discipline"] && params["mirs_discipline"] !== ALL_URL.ALL_DISC)) || (params["mirs_noc"] && params["mirs_noc"] !== ALL_URL.ALL_NOC) || filterText) {
                setIsResetFilterButtonDisabled(false);
            } else {
                setIsResetFilterButtonDisabled(true);
            }
        } else if (page === "coaches" || page === "teams") {
            if ((params["mirs_discipline"] && params["mirs_discipline"] !== ALL_URL.ALL_DISC) || (params["mirs_event"] && params["mirs_event"] !== ALL_URL.ALL_EVENT) || (params["mirs_noc"] && params["mirs_noc"] !== ALL_URL.ALL_NOC) || filterText) {
                setIsResetFilterButtonDisabled(false);
            } else {
                setIsResetFilterButtonDisabled(true);
            }
        } else if (page === "entries") {
            if ((params["mirs_event"] && params["mirs_event"] !== ALL_URL.ALL_EVENT) || (params["mirs_noc"] && params["mirs_noc"] !== ALL_URL.ALL_NOC)) {
                setIsResetFilterButtonDisabled(false);
            } else {
                setIsResetFilterButtonDisabled(true);
            }
        } else if (page === "records") {
            if ((params["mirs_event"] && params["mirs_event"] !== ALL_URL.ALL_EVENT) || (selectedNoc && selectedNoc !== ALL_URL.ALL_NOC) || selectedRecord || isBrokenRecordsSelected) {
                setIsResetFilterButtonDisabled(false);
            } else {
                setIsResetFilterButtonDisabled(true);
            }
        } else if (page === "athletesbynoc") {
            if ((params["mirs_discipline"] && params["mirs_discipline"] !== ALL_URL.ALL_DISC) || filterText) {
                setIsResetFilterButtonDisabled(false);
            } else {
                setIsResetFilterButtonDisabled(true);
            }
        } else if (page === "reports") {
            if ((params["mirs_event"] && params["mirs_event"] !== ALL_URL.ALL_EVENT) || (selectedPdfType && selectedPdfType !== ALL_URL.ALL_PDFs) || filterText) {
                setIsResetFilterButtonDisabled(false);
            } else {
                setIsResetFilterButtonDisabled(true);
            }
        }
    }, [filterText, page, params, isBrokenRecordsSelected, selectedGender, selectedNoc, selectedRecord, selectedPdfType]);

    function resetFilterHandler() {
        const paramsURL = { ...params }
        if (page === 'entries') {
            paramsURL['mirs_noc'] = '';
            paramsURL['mirs_event'] = '';
            setParamsUrl(paramsURL);
            setShouldNavigate(true);
        } else if (page === 'records') {
            onClearFilters();
            if (params["mirs_event"] && params["mirs_event"] !== ALL_URL.ALL_EVENT) {
                paramsURL['mirs_event'] = '';
                setParamsUrl(paramsURL);
                setShouldNavigate(true);
            }
        } else if (page === 'medallists') {
            onClearFilters();
            if ((params["mirs_event"] && params["mirs_event"] !== ALL_URL.ALL_EVENT) || (params["mirs_discipline"] && params["mirs_discipline"] !== ALL_URL.ALL_DISC) || (params["mirs_date"] && params["mirs_date"] !== ALL_URL.ALL_DAYS)) {
                paramsURL['mirs_event'] = '';
                paramsURL['mirs_discipline'] = '';
                paramsURL['mirs_date'] = '';
                setParamsUrl(paramsURL);
                setShouldNavigate(true);
            }
        } else if (page === 'multimedallists') {
            onClearFilters();
            if ((params["mirs_discipline"] && params["mirs_discipline"] !== ALL_URL.ALL_DISC)) {
                paramsURL['mirs_discipline'] = '';
                setParamsUrl(paramsURL);
                setShouldNavigate(true);
            }
        } else if (page === 'athletesbynoc') {
            onClearFilters();
            if ((params["mirs_discipline"] && params["mirs_discipline"] !== ALL_URL.ALL_DISC)) {
                paramsURL['mirs_discipline'] = '';
                setParamsUrl(paramsURL);
                setShouldNavigate(true);
            }
        } else if (page === 'reports') {
            onClearFilters();
            if ((params["mirs_event"] && params["mirs_event"] !== ALL_URL.ALL_EVENT)) {
                paramsURL['mirs_event'] = '';
                setParamsUrl(paramsURL);
                setShouldNavigate(true);
            }
        } else {
            paramsURL['mirs_event'] = '';
            paramsURL['mirs_date'] = '';
            paramsURL['mirs_noc'] = '';
            paramsURL['mirs_gender'] = '';
            paramsURL['mirs_discipline'] = '';
            clearCompetitorFilter();
            setParamsUrl(paramsURL);
            setShouldNavigate(true);
        }
    };

    function clearCompetitorFilter() {
        if (clearFilterText) {
            clearFilterText();
        };
    };

    return (<Button className="button_reset" onClick={resetFilterHandler} disabled={isResetFilterButtonDisabled}>
        <Label data={"LabelResetFilters"} />
    </Button>);
}
